// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminMenuItem_sidebar_menu_wrap__bbO1k {
  padding: 20px 0;
  margin: 0 20px;
  border-top: 1px solid var(--border-default-color);
}
.adminMenuItem_sidebar_menu_wrap__bbO1k ul {
  padding-left: 0px;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH {
  margin-right: 10px;
  display: flex;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH svg {
  width: 20px;
  height: 20px;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH svg path {
  fill: var(--primary-color);
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM span {
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  text-transform: uppercase;
  color: var(--primary-color);
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi {
  display: flex;
  align-items: center;
  padding: 10px 0 10px 25px;
  background-color: transparent;
  transition: all 0.3s;
  cursor: pointer;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_icon__TOP4O {
  display: flex;
  align-items: center;
  margin-right: 10px;
  width: 20px;
  height: 20px;
  pointer-events: none;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_icon__TOP4O path {
  fill: #000;
  transition: all 0.3s;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_item__9rND- {
  opacity: 1;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #000;
  transition: all 0.3s;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi:hover {
  background-color: #ffffff;
  transition: all 0.3s;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi:hover .adminMenuItem_menu_icon__TOP4O path {
  fill: var(--primary-color);
  transition: all 0.3s;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi:hover .adminMenuItem_menu_item__9rND- {
  color: var(--primary-color);
  transition: all 0.3s;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_active_item__W6e8t {
  background-color: #ffffff;
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_active_item__W6e8t .adminMenuItem_menu_icon__TOP4O path {
  fill: var(--primary-color);
}
.adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_active_item__W6e8t .adminMenuItem_menu_item__9rND- {
  color: var(--primary-color);
}
@media (max-width: 1440px) {
  .adminMenuItem_sidebar_menu_wrap__bbO1k {
    padding: 15px 0;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM {
    margin-bottom: 10px;
  }
}
@media (max-width: 1199px) {
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH svg {
    width: 18px;
    height: 18px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM span {
    font-size: 15px;
    line-height: 16px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi {
    padding: 7px 0 7px 10px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_icon__TOP4O {
    width: 16px;
    height: 16px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_item__9rND- {
    font-size: 15px;
    line-height: 16px;
  }
}
@media (max-width: 991px) {
  .adminMenuItem_sidebar_menu_wrap__bbO1k {
    padding: 13px 0;
    margin: 0 15px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM {
    margin-bottom: 10px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH {
    margin-right: 5px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH svg {
    width: 15px;
    height: 15px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM span {
    font-size: 14px;
    line-height: 1;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_icon__TOP4O {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_item__9rND- {
    font-size: 14px;
    padding: 3px 0;
    line-height: 1;
  }
}
@media (max-width: 800px) {
  .adminMenuItem_sidebar_menu_wrap__bbO1k {
    padding: 10px 0;
    margin: 0 10px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM {
    margin-bottom: 8px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM .adminMenuItem_menu_title_icon__awlOH {
    margin-right: 3px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_title__eehwM span {
    font-size: 12px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_icon__TOP4O {
    margin-right: 3px;
  }
  .adminMenuItem_sidebar_menu_wrap__bbO1k .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_item__9rND- {
    font-size: 12px;
  }
}

.adminMenuItem_close_sidebar__c7pGV {
  margin: 0 5px;
}
.adminMenuItem_close_sidebar__c7pGV .adminMenuItem_title__eehwM {
  justify-content: center;
}
.adminMenuItem_close_sidebar__c7pGV .adminMenuItem_title__eehwM span {
  display: none;
}
.adminMenuItem_close_sidebar__c7pGV .adminMenuItem_menu_item_wrap__ByRdi {
  margin: 5px;
  padding: 10px 5px;
  justify-content: center;
}
.adminMenuItem_close_sidebar__c7pGV .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_icon__TOP4O {
  margin-right: 0;
  pointer-events: none;
  width: 20px;
  height: 20px;
}
.adminMenuItem_close_sidebar__c7pGV .adminMenuItem_menu_item_wrap__ByRdi .adminMenuItem_menu_item__9rND- {
  opacity: 0;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden;
  transition: all 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/app/components/AdminPanel/AdminMenuItem/adminMenuItem.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,cAAA;EACA,iDAAA;AACD;AAAC;EACC,iBAAA;AAEF;AACC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACC,kBAAA;EACA,aAAA;AACH;AACG;EACC,WAAA;EACA,YAAA;AACJ;AAAI;EACC,0BAAA;AAEL;AAGE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;AADH;AAKC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;AAHF;AAKE;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAHH;AAIG;EACC,UAAA;EACA,oBAAA;AAFJ;AAME;EACC,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;AAJH;AAOE;EACC,yBAAA;EACA,oBAAA;AALH;AAQI;EACC,0BAAA;EACA,oBAAA;AANL;AAUG;EACC,2BAAA;EACA,oBAAA;AARJ;AAaC;EACC,yBAAA;AAXF;AAcG;EACC,0BAAA;AAZJ;AAgBE;EACC,2BAAA;AAdH;AAkBC;EAjGD;IAkGE,eAAA;EAfA;EAgBA;IACC,mBAAA;EAdD;AACF;AAiBC;EAGG;IACC,WAAA;IACA,YAAA;EAjBH;EAoBC;IACC,eAAA;IACA,iBAAA;EAlBF;EAsBA;IACC,uBAAA;EApBD;EAsBC;IACC,WAAA;IACA,YAAA;EApBF;EAuBC;IACC,eAAA;IACA,iBAAA;EArBF;AACF;AAyBC;EArID;IAsIE,eAAA;IACA,cAAA;EAtBA;EAuBA;IACC,mBAAA;EArBD;EAsBC;IACC,iBAAA;EApBF;EAqBE;IACC,WAAA;IACA,YAAA;EAnBH;EAsBC;IACC,eAAA;IACA,cAAA;EApBF;EAyBC;IACC,WAAA;IACA,YAAA;IACA,iBAAA;EAvBF;EA0BC;IACC,eAAA;IACA,cAAA;IACA,cAAA;EAxBF;AACF;AA2BC;EArKD;IAsKE,eAAA;IACA,cAAA;EAxBA;EAyBA;IACC,kBAAA;EAvBD;EAwBC;IACC,iBAAA;EAtBF;EAwBC;IACC,eAAA;EAtBF;EA2BC;IACC,iBAAA;EAzBF;EA4BC;IACC,eAAA;EA1BF;AACF;;AA+BA;EACC,aAAA;AA5BD;AA8BC;EACC,uBAAA;AA5BF;AA6BE;EACC,aAAA;AA3BH;AA+BC;EACC,WAAA;EACA,iBAAA;EACA,uBAAA;AA7BF;AAiCE;EACC,eAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AA/BH;AAiCE;EACC,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oBAAA;AA/BH","sourcesContent":[".sidebar_menu_wrap {\n padding: 20px 0;\n margin: 0 20px;\n border-top: 1px solid var(--border-default-color);\n ul {\n  padding-left: 0px;\n }\n\n .title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n\n  .menu_title_icon {\n   margin-right: 10px;\n   display: flex;\n\n   svg {\n    width: 20px;\n    height: 20px;\n    path {\n     fill: var(--primary-color);\n    }\n   }\n  }\n\n  span {\n   font-weight: 700;\n   font-size: 16px;\n   line-height: 18px;\n   text-transform: uppercase;\n   color: var(--primary-color);\n  }\n }\n\n .menu_item_wrap {\n  display: flex;\n  align-items: center;\n  padding: 10px 0 10px 25px;\n  background-color: transparent;\n  transition: all 0.3s;\n  cursor: pointer;\n\n  .menu_icon {\n   display: flex;\n   align-items: center;\n   margin-right: 10px;\n   width: 20px;\n   height: 20px;\n   pointer-events: none;\n   path {\n    fill: #000;\n    transition: all 0.3s;\n   }\n  }\n\n  .menu_item {\n   opacity: 1;\n   font-weight: 400;\n   font-size: 18px;\n   line-height: 21px;\n   color: #000;\n   transition: all 0.3s;\n  }\n\n  &:hover {\n   background-color: #ffffff;\n   transition: all 0.3s;\n\n   .menu_icon {\n    path {\n     fill: var(--primary-color);\n     transition: all 0.3s;\n    }\n   }\n\n   .menu_item {\n    color: var(--primary-color);\n    transition: all 0.3s;\n   }\n  }\n }\n\n .active_item {\n  background-color: #ffffff;\n\n  .menu_icon {\n   path {\n    fill: var(--primary-color);\n   }\n  }\n\n  .menu_item {\n   color: var(--primary-color);\n  }\n }\n\n @media (max-width: 1440px) {\n  padding: 15px 0;\n  .title {\n   margin-bottom: 10px;\n  }\n }\n\n @media (max-width: 1199px) {\n  .title {\n   .menu_title_icon {\n    svg {\n     width: 18px;\n     height: 18px;\n    }\n   }\n   span {\n    font-size: 15px;\n    line-height: 16px;\n   }\n  }\n\n  .menu_item_wrap {\n   padding: 7px 0 7px 10px;\n\n   .menu_icon {\n    width: 16px;\n    height: 16px;\n   }\n\n   .menu_item {\n    font-size: 15px;\n    line-height: 16px;\n   }\n  }\n }\n\n @media (max-width: 991px) {\n  padding: 13px 0;\n  margin: 0 15px;\n  .title {\n   margin-bottom: 10px;\n   .menu_title_icon {\n    margin-right: 5px;\n    svg {\n     width: 15px;\n     height: 15px;\n    }\n   }\n   span {\n    font-size: 14px;\n    line-height: 1;\n   }\n  }\n\n  .menu_item_wrap {\n   .menu_icon {\n    width: 14px;\n    height: 14px;\n    margin-right: 5px;\n   }\n\n   .menu_item {\n    font-size: 14px;\n    padding: 3px 0;\n    line-height: 1;\n   }\n  }\n }\n @media (max-width: 800px) {\n  padding: 10px 0;\n  margin: 0 10px;\n  .title {\n   margin-bottom: 8px;\n   .menu_title_icon {\n    margin-right: 3px;\n   }\n   span {\n    font-size: 12px;\n   }\n  }\n\n  .menu_item_wrap {\n   .menu_icon {\n    margin-right: 3px;\n   }\n\n   .menu_item {\n    font-size: 12px;\n   }\n  }\n }\n}\n\n.close_sidebar {\n margin: 0 5px;\n\n .title {\n  justify-content: center;\n  span {\n   display: none;\n  }\n }\n\n .menu_item_wrap {\n  margin: 5px;\n  padding: 10px 5px;\n  justify-content: center;\n }\n\n .menu_item_wrap {\n  .menu_icon {\n   margin-right: 0;\n   pointer-events: none;\n   width: 20px;\n   height: 20px;\n  }\n  .menu_item {\n   opacity: 0;\n   width: 0 !important;\n   height: 0 !important;\n   overflow: hidden;\n   transition: all 0.3s;\n  }\n }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar_menu_wrap": `adminMenuItem_sidebar_menu_wrap__bbO1k`,
	"title": `adminMenuItem_title__eehwM`,
	"menu_title_icon": `adminMenuItem_menu_title_icon__awlOH`,
	"menu_item_wrap": `adminMenuItem_menu_item_wrap__ByRdi`,
	"menu_icon": `adminMenuItem_menu_icon__TOP4O`,
	"menu_item": `adminMenuItem_menu_item__9rND-`,
	"active_item": `adminMenuItem_active_item__W6e8t`,
	"close_sidebar": `adminMenuItem_close_sidebar__c7pGV`
};
export default ___CSS_LOADER_EXPORT___;
